import styles from "./AdmissionInfo.module.css";

export default function AdmissionInfo() {
  return (
    <section className={styles.AdmissionPage} id="admission">
      <h2 className={styles.PageName}>Admissions Information</h2>
      <div className={styles.admissionDetails}>
        <section className={styles.AdmissionImage}>
          <img src="/admission.webp" alt="admission" />
        </section>

        <section className={styles.textContent}>
          <p>
            K. P. Jadhav Junior College is affiliated with the Maharashtra State
            Board of Secondary and Higher Secondary Education, Pune, and offers
            courses in Arts, Commerce, and Science for grades 11 and 12.
            Students seeking admission to the 11th and 12th grades in Arts,
            Commerce, or Science must fulfill the following requirements at the
            time of admission:
          </p>

          <ul>
            {/* <li>
                             Download the admission form using the "Download Form" button, complete it accurately, and attach a photograph.
                        </li> */}
            <li>
              Click "Apply Now" to complete your admission through the official
              government portal.
            </li>
            <li>
              The original school or college leaving certificate along with a
              photocopy.
            </li>
            <li>
              The original mark sheet of the last completed grade, along with
              two photocopies.
            </li>
            <li>Admission fees.</li>
            <li>A photocopy of the Aadhaar card.</li>
          </ul>
          {/* <a
            href="/forms/K.P. Jadhav-AdmissionForm.pdf"
            download
            className={styles.downloadForm}
          >
            Apply Now
          </a> */}
          <a
            href="https://mahafyjcadmissions.in"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.downloadForm}
          >
            Apply Now
          </a>
        </section>
      </div>
    </section>
  );
}
